/**
 * Routeur Flux de déchets (remplace l’ancien écran avec modales).
 * Utilisé par SettingsWaste et tout import legacy de ce module.
 */
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/PageHeader";
import HowItWorksButton from "../../components/howItWorks/HowItWorksButton";
import SettingsWasteList from "../settings/waste/SettingsWasteList";
import SettingsWasteEditor from "../settings/waste/SettingsWasteEditor";
import MaterialsCatalogPage from "../settings/materials/MaterialsCatalogPage";
import WasteLegacyRedirect from "../settings/waste/WasteLegacyRedirect";

const BASE_PATH = "/settings/waste";

const Waste = ({ token, API }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  if (location.pathname === "/waste") {
    return <WasteLegacyRedirect />;
  }

  if (location.pathname.startsWith(BASE_PATH)) {
    return (
      <Switch>
        <Route exact path={BASE_PATH}>
          <div className="settings-page-wrapper">
            <PageHeader
              title={t("Waste Flows")}
              showBackButton
              backRoute="/settings"
              backLabel={t("Back to Settings")}
              helpButton={
                <>
                  <button
                    type="button"
                    className="page-header-pill"
                    onClick={() => history.push(`${BASE_PATH}/materials`)}
                  >
                    <i className="fas fa-swatchbook" aria-hidden />
                    <span>{t("materialsCatalog.openFromFlows")}</span>
                  </button>
                  <HowItWorksButton topic="wasteFlows" />
                </>
              }
            />
            <SettingsWasteList
              token={token}
              API={API}
              basePath={BASE_PATH}
              hidePageHeader
            />
          </div>
        </Route>
        <Route exact path={`${BASE_PATH}/new`}>
          <SettingsWasteEditor
            token={token}
            API={API}
            mode="create"
            basePath={BASE_PATH}
          />
        </Route>
        {/* Doit rester avant la route /:id, qui capterait sinon "materials". */}
        <Route exact path={`${BASE_PATH}/materials`}>
          <MaterialsCatalogPage token={token} API={API} basePath={BASE_PATH} />
        </Route>
        <Route path={`${BASE_PATH}/:id`}>
          <SettingsWasteEditor
            token={token}
            API={API}
            mode="edit"
            basePath={BASE_PATH}
          />
        </Route>
      </Switch>
    );
  }

  return <WasteLegacyRedirect />;
};

export default Waste;
